
import { PropTypes } from 'prop-types';
import { DecodeHtml } from '../../utils/decodeHtml';
import { apis } from '../../api/apiUrl';

const ModelView = ({ title, description }) => {
   

   
    return (
        <div className="flex flex-col gap-5 w-full  p-4 max-h-[80vh] max-w-[80vw]  ">
            <h1 className=" text-zinc-950 text-xl sm:text-3xl font-bold">{title}</h1>
            <p className="text-sky-950 text-opacity-70 text-lg font-normal overflow-y-auto scroll-bar">
                {
                    DecodeHtml({html:description})
                }
            </p>

        </div>
    )
}
ModelView.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string
}
export default ModelView